module.exports = __webpack_public_path__ + "logo.a961dfbf36f110092c3f.png";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/logo.png
// module id = ../../../../../src/assets/img/logo.png
// module chunks = styles